'use strict';

import type { Plan } from '../Entities/Plan';
import { EntityCollection } from './EntityCollection';

export class PlanCollection extends EntityCollection<Plan> {}
